module.exports = __webpack_public_path__ + "public/img/11Code.1db087e1.png";